import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    DataTableSelectionBarDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap"
    },
    overlay: {
        position: "absolute",
        flexWrap: "nowrap",
        start: 0,
        end: 0
    },
    count: {
        flexShrink: 1,
        minWidth: 0
    },
    spacer: {
        flexGrow: 1
    }
});

export const useStyles = ({
    controlHeights,
    toolbarLayout,
    colors,
    spaces
}: DataTableSelectionBarDynamicStyleType) => {
    const styles = {
        container: {
            minHeight: controlHeights.small + spaces.spacingMd * 2,
            backgroundColor: colors.content.container.selected,
            paddingHorizontal: spaces.spacingMd,
            paddingVertical: spaces.spacingMd,
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>,
        count: {
            marginEnd: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    if(toolbarLayout) {
        Object.assign(styles.container, {
            height: toolbarLayout.height,
            top: toolbarLayout.y
        });
    }

    return styles;
};
export default stylesheet;
